var styles = {
  "Footer": "Online-Store-UI-Footer_ihd4e",
  "toneMagic": "Online-Store-UI-Footer--toneMagic_f3v2h",
  "unframed": "Online-Store-UI-Footer--unframed_1n012"
};

export { styles as default };
